module.exports = __webpack_public_path__ + "static/media/earnedInADay_50000_75000.2f701cbf.png";